import { Flex, Text } from '@chakra-ui/react';

import { Input } from '@revelio/ui';

import type { FilterOperator } from '../../data-builder.store';
import { customFilterInputCssVars } from './disabled-input-overrides';
import { isInBetweenOperator } from './string-filter-operators';

type NumericFilterValueInputProps = {
  values: string[];
  onChange: (values: string[]) => void;
  operator: FilterOperator | null;
  isDisabled: boolean;
  required?: boolean;
};

export function NumericFilterValueInput({
  values,
  onChange,
  operator,
  isDisabled,
  required = false,
}: NumericFilterValueInputProps) {
  const minValue = values[0] ?? '';
  const maxValue = values[1] ?? '';

  if (isInBetweenOperator(operator)) {
    return (
      <Flex gap={2} alignItems="center">
        <Input
          size="sm"
          type="number"
          step="any"
          placeholder="Min"
          max={maxValue === '' ? undefined : maxValue}
          value={minValue}
          onChange={(e) => {
            onChange([e.target.value, maxValue]);
          }}
          disabled={isDisabled}
          required={required}
          cssVars={customFilterInputCssVars}
          data-testid="numeric-filter-min-input"
        />
        <Text fontSize="sm" whiteSpace="nowrap">
          to
        </Text>
        <Input
          size="sm"
          type="number"
          step="any"
          placeholder="Max"
          min={minValue === '' ? undefined : minValue}
          value={maxValue}
          onChange={(e) => {
            onChange([minValue, e.target.value]);
          }}
          disabled={isDisabled}
          required={required}
          cssVars={customFilterInputCssVars}
          data-testid="numeric-filter-max-input"
        />
      </Flex>
    );
  }

  return (
    <Input
      size="sm"
      type="number"
      step="any"
      placeholder="Value"
      value={minValue}
      onChange={(e) => {
        onChange([e.target.value]);
      }}
      disabled={isDisabled}
      required={required}
      cssVars={customFilterInputCssVars}
      data-testid="numeric-filter-value-input"
    />
  );
}
